export default {
  admin: import('./admin'),
  brands: import('./brands'),
  products: import('./products'),
  reports: import('./reports'),
  dashboard: import('./dashboard'),
  placement: import('./placement'),
  sellerAccount: import('./sellerAccount'),
  cpc: import('./cpc'),
}
export { default as connectionApi } from './connection';
export { default as whitelistApi } from './whitelist';